export class Notification {
  message: string;
  /** The icon to be shown to the user, use the base class name of the icon.
   * @default `info`
   * @example `browser_updated` == mui/icons-material/BrowserUpdated
   */
  icon: string;
  viewed: boolean;

  constructor(message: string, icon = "info") {
    this.message = message;
    this.icon = icon;
    this.viewed = false;
  }
}
